module.exports = __webpack_public_path__ + "images/v2-home-features.webp";